import getStringEnvVar from 'lib/getStringEnvVar';

import routes from 'constants/routes';

export const getCoinbaseRedirectUri = () =>
  `${getStringEnvVar('REACT_APP_BASE_URL')}${routes.accounts.coinbaseAuth.path}`;

export const getCoinbaseOAuthRedirectUri = () =>
  `${getStringEnvVar('REACT_APP_BASE_URL')}${routes.oauth.coinbase.path}`;
